import OrderPill from '@/features/orders/components/OrderListItem/OrderPill'
import OrderListItemContext from '@/features/orders/components/OrderListItem/contexts/OrderListItem'
import { statePillToneMap } from '@/features/orders/components/OrderListItem/utils/statePillToneMap'
import { State as StateEnum } from '@/features/orders/constants/app'
import { isDeliveryOrder } from '@/utils/isDeliveryOrder'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useContextSelector } from 'use-context-selector'

const State: FC = () => {
    const order = useContextSelector(OrderListItemContext, ({ order }) => order)

    const { t } = useTranslation()

    const translationState: StateEnum | `${StateEnum.Ready}_for_delivery` =
        order.state === StateEnum.Ready && isDeliveryOrder(order)
            ? `${order.state}_for_delivery`
            : order.state

    return (
        <OrderPill tone={statePillToneMap[order.state]}>
            {t(`order.state.${translationState}`, order.state)}
        </OrderPill>
    )
}

export default State
